import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';
import { IMAGES, SITE } from '../data/site';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('beh_admin_token', data.token);
      toast.success('Welcome back.');
      navigate('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const inputCls = 'w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-base text-navy outline-none transition-all focus:border-brand focus:ring-2 focus:ring-brand/20';

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy-dark px-4 grain relative" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        <img src={IMAGES.logo} alt={`${SITE.name} admin login`} className="mx-auto h-12 w-auto rounded-md" />
        <h1 className="mt-6 text-center font-display text-2xl font-bold text-navy">Admin Login</h1>
        <p className="mt-1 text-center text-sm text-slate-500">Leads dashboard access</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label htmlFor="admin-email" className="mb-1 block text-xs font-bold uppercase tracking-wider text-slate-500">Email</label>
            <input id="admin-email" data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="admin@beholbrooks.com" />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1 block text-xs font-bold uppercase tracking-wider text-slate-500">Password</label>
            <input id="admin-password" data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-brand py-3.5 font-display text-base font-bold text-white transition-all hover:bg-brand-dark disabled:opacity-60"
          >
            <LogIn className="h-4 w-4" /> {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <a href="/" className="mt-6 block text-center text-xs font-medium text-slate-400 hover:text-brand" data-testid="admin-back-home">
          Back to website
        </a>
      </div>
    </div>
  );
}
